import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import icoback from '../img/ico-back.svg';
import strings from '../strings.js'
import { SendMessage } from '../App.js';
import useSongSearch from '../useSongSearch';
import useDurationSearch from '../useDurationSearch';
import TableCardOverview from '../TableCardOverview';

const API_URL = "https://starboxkod.com/api";

const song1 = {
    "song_num": 110108,
    "song_name": "给我多一点",
    "singer": "SHE",
    "language": "国语",
    "server_id": "C",
    "rel_path": "05\\110108"
}



export function Overview({skin, stateNextTable, stateDuration, stateVer, stateTables, lang, statePlaylist, statePlaylistYT, tableNo, statePlaybackSong, statePlaybackYT}) {

    const [pageNumber, setPageNumber] = useState(0);

    const {
        loading,
        error,
        songs,
        hasMore
    } = useSongSearch(statePlaybackSong, pageNumber)

    const {
        maxDuration,
    } = useDurationSearch(songs)
    // Calculate minutes and seconds
    const maxMinutes = Math.floor(maxDuration / 60);
    const maxSeconds = Math.floor(maxDuration % 60);
    
// Format minutes and seconds
const formattedMaxDuration = `${maxMinutes}:${maxSeconds < 10 ? '0' : ''}${maxSeconds}`;

    const curMinutes = Math.floor(stateDuration / 60);
    const curSeconds = Math.floor(stateDuration % 60);

    // Format minutes and seconds
const formattedCurDuration = `${curMinutes}:${curSeconds < 10 ? '0' : ''}${curSeconds}`;


//const playingTable = Object.keys(stateTables).find(tableName => stateTables[tableName].playing === true);

let playingTable = null;

Object.keys(stateTables).forEach(table => {
    if (stateTables[table].playing) {
        playingTable = table.substring(1);
    }
});

//console.log("Playing table:", playingTable);


    const navigate = useNavigate()

    return (<>




<div className="purpleHeader26Overview" style={{marginTop:'0'}}>





    <div className="heatder" style={{backgroundImage:'none'}}>
        <a onClick={(e) => {e.preventDefault(); navigate(-1); console.log(playingTable);}}>
        <img
            src={icoback}
            alt="home"
        />
        </a>
        

        <div className="headerReplaceTextA"style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex' }}>
            <span className="headerReplaceTextS" style={{ minWidth: lang?'90px':'130px', marginRight: '10px' }}>{lang ? strings.cn.nowPlaying : strings.en.nowPlaying}</span>:&nbsp;&nbsp;
            {playingTable && (lang ? strings.cn.table : strings.en.table) + " " + playingTable}
        </div>
        { !isNaN(stateDuration) ? (
            <div style={{ display: 'flex' }}>
                <span className="headerReplaceTextS" style={{ minWidth: lang?'90px':'130px', marginRight: '10px' }}>{lang ? strings.cn.nextPlaying : strings.en.nextPlaying}</span>:&nbsp;&nbsp;
                {stateNextTable && (lang ? strings.cn.table : strings.en.table) + " " + stateNextTable}
            </div>
        ) : (
            <></>
        ) }
    </div>


        {/* <div className = "headerEndText">{statePlaylist == "" ? [].length : statePlaylist.split(',').length}</div> */}
    </div>

    { statePlaybackSong == "1111" ? (
    
    <>
    <div className="overview-nowplaying" onClick={(e)=> {e.preventDefault();}}>
        <img className="overview-nowplaying-photo"
            src={`${API_URL}/profile-image/YOUTUBE`}
            onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src="https://via.placeholder.com/100";
            }}
            alt={statePlaybackYT.substring(0, 20)}/>
        <div className="overview-nowplaying-right">
            <div className="overview-nowplaying-title">
                {statePlaybackYT.substring(0, 20)}
            </div>
            <div className="overview-nowplaying-title">
                YOUTUBE
            </div>
        </div>
    </div>
    </>
   ) : (
    <>
    <div className="overview-nowplaying" onClick={(e)=> {e.preventDefault();}}>
        <img className="overview-nowplaying-photo"
            src={`${API_URL}/profile-image/${songs[0]?.singer}`}
            onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src="https://via.placeholder.com/100";
            }}
            alt={songs[0]?.song_name}/>
        <div className="overview-nowplaying-right" style={{flexGrow:'1', width:'20vw'}}>
            <div className="overview-nowplaying-title">
                {songs[0]?.song_name}
            </div>
            <div className="overview-nowplaying-title" style={{ display: 'flex', alignItems: 'flex-end'}}>
                <div style={{ flexGrow: 1, flexBasis: 0, overflow: 'hidden', textOverflow: 'clip', whiteSpace: 'nowrap', width:'20vw'}}>
                {songs[0]?.singer} {songs[0]?.singer2 && `, ${songs[0]?.singer2}`} {songs[0]?.singer3 && `, ${songs[0]?.singer3}`}
                </div>


                { !isNaN(stateDuration) ? (
                <div style={{ marginBottom: '5px', borderRadius: '10px', flexGrow: 1, flexBasis: 0, height: '7.5px', backgroundColor: '#eee', position: 'relative' , width:'20vw'}}>
                    <div
                    style={{
                        width: `${(stateDuration / maxDuration) * 100}%`,
                        height: '7.5px',
                        backgroundColor: skin ? '#ff8f2b':'#33cc66',
                        borderRadius: '10px',
                    }}
                    ></div>
                    <div style={{ position: 'absolute', bottom: '-15px', left: 0, padding: '2px', fontSize: '10px' }}>{formattedCurDuration}</div>
                    <div style={{ position: 'absolute', bottom: '-15px', right: 0, padding: '2px', fontSize: '10px' }}>{formattedMaxDuration}</div>
                </div>
                ) : (
                    <></>
                ) }


            </div>   
        </div>




       



    </div>
    </>
    )}


    







</div>







    
    <div className="overview-container">
    {Object.keys(stateTables)?.length > 0
        ? (
        <>
            {Object.keys(stateTables).map((keyName, index) => {
                return <TableCardOverview skin={skin} tableName={keyName} table={stateTables[keyName]} lang={lang} key={index} jiheonIndex={index}/>
            })}     
        </>
        ) :
        (
        <div className="empty">
            <h2>No songs found</h2>
        </div>
    )}
</div>
</>)}
